import './Udaan.css';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel'

const Home = ({children}) => {
  const [message, setMessage] = useState("");

    const navigate = useNavigate();

    const handleAdminNavigation = (event) => {
        event.preventDefault();
        const user = JSON.parse(sessionStorage.getItem("user"));

        if (user && user.userRole === "1") {
            navigate("/admin-home");  // Redirect to admin home if authenticated
        } else {
            navigate("/admin-login"); // Redirect to login if not authenticated
        }
    };

  return (
     <div>
          <div class="main-menu">
          <div class="container">
           <div class="row">
           <div class="logo col-md-4 col-5"><a onClick={()=>navigate("/")} style={{cursor: "pointer"}}><img src="../logo.png" alt="nope"/></a></div>
          <div class="menu col-md-8 col-8">
          <a aria-current="page" class="active" onClick={()=>navigate("/")} style={{cursor: "pointer"}}>Home</a>
          <div class="menu-menu">
              <a class="" onClick={()=>navigate("/about")} style={{cursor: "pointer"}}>About Us</a>
              <div class="sub-menu">
                  <a onClick={()=>navigate("/History")} style={{cursor: "pointer"}}>History</a>
                  <a onClick={()=>navigate("/members")} style={{cursor: "pointer"}}>Committee Members</a>
                  <a className="sub_header_links" onClick={()=>navigate("/sponsors")} style={{cursor: "pointer"}}>Our Sponsors</a>
               {/*<a href="/comingSoon">Contact Us</a> */}
              </div>
          </div>
          <div class="menu-menu">
          <a className="header_links" onClick={()=>navigate("/Philanthropic")} style={{cursor: "pointer"}}>Philanthropy</a>
          </div>

       
          <a class="" href="#" onClick={handleAdminNavigation}>Admin</a>
         {/*  <a class="" href="/charity">Charity</a> */}
          {/* <a class="" href="/contact">Contact Us</a> */}
          <div class="menu-action-buttons">
              {/* <a href="/cart-page">
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                      <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M80 176a16 16 0 0 0-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 0 0-16-16zm80 0v-32a96 96 0 0 1 96-96h0a96 96 0 0 1 96 96v32"></path>
                  </svg>
                  <span> </span>
              </a>*/}
          </div>
      </div>
      </div>
      </div>
      <nav class="navbar navbar-expand-lg navbar-light bg-light navbar_for_mobile">
        <a class="navbar-brand"></a>
        <button class="navbar-toggler" style={{position: 'relative', left:' 310px'}} type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
            <li class="nav-item active">
                <a class="nav-link" onClick={()=>navigate("/")}>Home <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                About Us
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <a class="dropdown-item" onClick={()=>navigate("/about")}>About Us</a>
                <a class="dropdown-item" onClick={()=>navigate("/History")}>History</a>
                <a class="dropdown-item" onClick={()=>navigate("/members")}>Committee Member</a>
                <a class="dropdown-item" onClick={()=>navigate("/sponsors")}> Our Sponsors </a>
                </div>
            </li>
            <li class="nav-item">
                <a class="nav-link" onClick={()=>navigate("/Philanthropic")}>Philanthropy</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" onClick={handleAdminNavigation}>Admin</a>
            </li>
            </ul>
        </div>
      </nav>
      </div>
      
      {/* The carousel block below will be it's own component in future/}
      {/* <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false} showArrows={false} interval={3000}>
                      <div>
                          <img src="./DurgaPujo1.jpg" />
                          <a className="legend"href='/about' >Register Now for early bird pricing!!</a>
                      </div>
                      <div>
                          <img src="./DurgaPujo2.jpg" />
                      </div>
                      <div>
                          <img src="./DurgaPujo3.jpg" />

                      </div>
                  </Carousel> */}

      <main class="maincontent">{children}</main>

      <div class="footer-section">
          <footer class="tp-site-footer">
              <div class="tp-upper-footer">
                  <div class="container">
                      <div class="row">
                          <div class="col col-lg-3 col-md-6 col-sm-12 col-12">
                              <div class="widget about-widget">
                                  <div class="footer-logo widget-title">
                                      <a  onClick={()=>navigate("/")}>
                                          <div class="logo">
                                              <img src="/logo.png" alt=""/>
                                          </div>
                                      </a>
                                  </div>
                                  <ul>
                                      <li><a href="https://www.facebook.com/pragatiphila"><i class="ti-facebook"></i></a></li>
                                      <li><a href="https://www.instagram.com/pragatiphilly/"><i class="ti-instagram"></i></a></li>
                                      <li><a onClick={()=>navigate("/")} style={{cursor: "pointer"}}><i class="ti-google"></i></a></li>
                                  </ul>
                              </div>
                          </div>
                          <div class="col col-lg-2 col-md-6 col-sm-12 col-12">
                              <div class="widget link-widget">
                                  <div class="widget-title">
                                      <h3>Useful Links</h3>
                                  </div>
                                  <ul>
                                      <li><a onClick={()=>navigate("/about/")} style={{cursor: "pointer"}}>About Us</a></li>
                                  </ul>
                              </div>
                          </div>
                          <div class="col col-lg-3 col-lg-offset-1 col-md-6 col-sm-12 col-12">
                              <div class="widget market-widget tp-service-link-widget">
                                  <div class="widget-title">
                                      <h3>Contact</h3>
                                  </div>
                                  <div class="contact-ft">
                                      <ul>
                                          <li><i className="fi flaticon-pin"></i>PO Box #704, 125 Rickey Blvd, Bear, DE
                                              19701-9998
                                          </li>
                                          <li><i className="fi flaticon-call"></i>Contact : 303-834-5394</li>
                                          <li><i className="fi flaticon-call"></i>Tax ID : 30-0795078</li>
                                          <li><i className="fi flaticon-envelope"></i>udaan.de@gmail.com</li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                          <div class="col col-lg-3 col-md-6 col-sm-12 col-12">
                              <div class="widget instagram">
                                  <div class="widget-title">
                                      <h3 style={{ textAlign:'left'}}>Social Media</h3>
                                  </div>
                                  <ul class="d-flex">
                                      <li>
                                          <a href="https://www.facebook.com/udaan.de" target="_blank" rel="noopener noreferrer">
                                              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"></path>
                                              </svg>
                                          </a>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="tp-lower-footer">
                  <div class="container">
                      <div class="row">
                          <div class="col col-xs-12">
                              <p class="copyright">© 2025 UDAAN. All rights reserved</p>
                          </div>
                      </div>
                  </div>
              </div>
          </footer>
      </div>


      </div>



  );
}

export default Home;
